import { render } from "./PageGroup.vue?vue&type=template&id=49c22b54"
import script from "./PageGroup.vue?vue&type=script&lang=js"
export * from "./PageGroup.vue?vue&type=script&lang=js"

import "./PageGroup.vue?vue&type=style&index=0&id=49c22b54&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__